import roundNumber from './roundNumber';

/**
 * Formats a given number as U.S. currency (dollars)
 *
 * @example
 * import formatCurrency from '@carvana/futilities/formatCurrency';
 * formatCurrency(20)
 * // () => '$20'
 * formatCurrency(19.30)
 * // () => '$19.30'
 *
 * @kind function
 * @name formatCurrency
 * @sig Number -> String
 * @param {Number} value The numeric value to be converted to currency
 * @returns {String} The original number formatted as U.S. currency
 */
function formatCurrency(value: number) {
  return `${roundNumber(value, 2)}`;
}

export default formatCurrency;
